import { render, staticRenderFns } from "./NicheWorshipGoods.vue?vue&type=template&id=32971a56&scoped=true"
import script from "./NicheWorshipGoods.vue?vue&type=script&lang=js"
export * from "./NicheWorshipGoods.vue?vue&type=script&lang=js"
import style0 from "./NicheWorshipGoods.vue?vue&type=style&index=0&id=32971a56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32971a56",
  null
  
)

export default component.exports